import React, { useState } from 'react';
import { NavLink } from "react-router";
import { HashLink } from "react-router-hash-link";

const Navbar = () => {
    const [showProducts, setShowProducts] = useState(false);
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const closeMenu = () => {
        setIsMenuOpen(false);
        setShowProducts(false);
    };



    return (
        <div className={'fixed h-20 w-full bg-white bg-opacity-70 flex items-center justify-center z-10'}>
            <div className={'flex items-center justify-between w-full max-w-screen-2xl p-4 md:justify-center'}>
                <p className={'font-semibold text-xl md:absolute md:left-10'}>
                    Delice
                </p>

                {/* Mobile Menu Toggle */}
                <div className="md:hidden">
                    <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="focus:outline-none">
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16m-7 6h7" />
                        </svg>
                    </button>
                </div>

                {/* Navbar Links */}
                <div className={`md:flex gap-8 items-center ${isMenuOpen ? 'absolute top-20 left-0 w-full bg-white flex flex-col shadow-md p-4' : 'hidden md:flex'}`}>
                    <NavLink to={'/'} className={({ isActive }) =>
                        isActive ? "text-red-500" : "text-black"
                    } onClick={closeMenu}>Home</NavLink>
                    <NavLink
                        className={({ isActive }) =>
                            isActive ? "text-red-500" : "text-black"
                        } to={'/about'}
                        onClick={closeMenu}
                    >About</NavLink>

                    {/* Product Dropdown */}
                    <div className="relative">
                        <p
                            className="cursor-pointer text-black"
                            onClick={() => setShowProducts(!showProducts)}
                        >
                            Product <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-4 w-4 ml-1 inline"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M19 9l-7 7-7-7"
                            />
                        </svg>
                        </p>
                        {showProducts && (
                            <div className="absolute top-full mt-2 left-0 bg-white shadow-md rounded-md w-48 md:w-56">
                                <ul className="flex flex-col text-black">
                                    <li className="p-2 hover:bg-gray-100" onClick={closeMenu}>
                                        <NavLink to="/products/dermal-filler">Dermal Filler</NavLink>
                                    </li>
                                    <li className="p-2 hover:bg-gray-100" onClick={closeMenu}>
                                        <NavLink to="/products/skin-booster">Skin Booster</NavLink>
                                    </li>
                                    <li className="p-2 hover:bg-gray-100" onClick={closeMenu}>
                                        <NavLink to="/products/mesotherapy">Mesotherapy Cocktails</NavLink>
                                    </li>
                                </ul>
                            </div>
                        )}
                    </div>
                    <HashLink to={'#contact'} smooth onClick={closeMenu}>Contact Us</HashLink>
                </div>
            </div>
        </div>
    );
};

export default Navbar;
